import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { MainLayout } from './components/layout/MainLayout';
import { CompanyListPage } from './pages/CompanyListPage';
import { CompanyDetailPage } from './pages/CompanyDetailPage';
import { CompanyComparisonPage } from './pages/CompanyComparisonPage';
import { ExecutiveDossierPage } from './pages/ExecutiveDossierPage';
import { SettingsPage } from './pages/SettingsPage';
import { UpdateSummaryPanel } from './components/company/UpdateSummaryPanel';
import { DossierAuthProvider } from './contexts/AuthContext';
import { ProtectedRoute, UnauthorizedPage } from './components/auth/ProtectedRoute';
import { ErrorBoundary } from './components/ErrorBoundary';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <ErrorBoundary>
      <DossierAuthProvider>
        <BrowserRouter
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <Routes>
            <Route element={<MainLayout />}>
              {/* Home route redirects authenticated users to companies dashboard */}
              <Route
                path="/"
                element={
                  <ProtectedRoute autoRedirect>
                    <Navigate to="/companies" replace />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/companies"
                element={
                  <ProtectedRoute>
                    <CompanyListPage />
                  </ProtectedRoute>
                }
              />
              {/* NOTE: /companies/compare MUST be before /:companyId to avoid path conflicts */}
              <Route
                path="/companies/compare"
                element={
                  <ProtectedRoute>
                    <CompanyComparisonPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/companies/:companyId"
                element={
                  <ProtectedRoute>
                    <CompanyDetailPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/companies/:companyId/updates"
                element={
                  <ProtectedRoute>
                    <UpdateSummaryPanel />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/companies/:companyId/executives/:executiveId/dossier"
                element={
                  <ProtectedRoute>
                    <ExecutiveDossierPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/settings"
                element={
                  <ProtectedRoute>
                    <SettingsPage />
                  </ProtectedRoute>
                }
              />
              <Route path="/unauthorized" element={<UnauthorizedPage />} />
            </Route>
            {/* Catch-all redirect */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
      </DossierAuthProvider>
    </ErrorBoundary>
  );
}

export default App;
